/* unplugin-vue-components disabled */import script from "./SkillsTree.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsTree.vue?vue&type=script&setup=true&lang=js"

import "./SkillsTree.vue?vue&type=style&index=0&id=614718be&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-614718be"]])

export default __exports__